<select2 (valueChanged)="onChange($event)"
         *ngIf="config.data.length"
         [data]="config.data"
         [name]="fieldName"
         [options]="config.options"
         [value]="currentModel"
         appSelect2Parent></select2>
